<script>
  import { Link, navigate } from "svelte-routing";
  import { onMount } from "svelte";

  //localStorage.setItem('uotp', "9159735017");
  const userotp = localStorage.getItem("uotp");

  if (userotp === null || userotp === "") {
    navigate("/fp");
  }

  onMount(() => {
    window.scrollTo(0, 0);
    const loggedin_user = localStorage.getItem("us");

    if (loggedin_user != null && !loggedin_user.isEmpty()) {
      navigate("/");
    }
  });

  let change_status = "";
  let change_status_data = "";
  const API_END_POINT = END_POINT;
  const api_url = API_END_POINT + "changepass.php";

  function preventDefault() {
    fetchdata();
  }

  async function countandredirect() {
    await new Promise((resolve) => setTimeout(resolve, 4000));
    localStorage.removeItem("uotp");
    navigate("/login");
  }

  async function fetchdata() {
    const otp = document.querySelector("#otp").value;
    const newpassword = document.querySelector("#newpassword").value;

    const response = await fetch(api_url, {
      method: "POST",
      body: JSON.stringify({ uphone: userotp, upass: newpassword, uotp: otp }),
    });

    const data = await response.json();

    const status = data.status;
    const status_data = data.content;

    change_status = status;
    change_status_data = status_data;

    if (status === "pass") {
      //console.log(status_data);
      countandredirect();
    }
  }
</script>

<svelte:head>
  <title>Change Password</title>
</svelte:head>

<main class="main-wrapper">
  <!-- ...:::Start User Event Section:::... -->
  <div class="header-section">
    <div class="container">
      <!-- Start User Event Area -->
      <div class="header-area">
        <div class="header-top-area header-top-area--style-1">
          <ul class="event-list justify-content-center">
            <li class="list-item">
              <h5 class="title text-center">
                <img
                  src="./logo.png"
                  alt="veeranfashions"
                  width="100px"
                  height="100px"
                />
                <br />Veeran Fashions
              </h5>
            </li>
          </ul>
        </div>
      </div>
      <!-- End User Event Area -->
    </div>
  </div>
  <!-- ...:::End User Event Section:::... -->

  <!-- ...:::Start Login Section:::... -->
  <div class="login-section">
    <div class="container">
      <!-- Start User Event Area -->
      <div class="login-wrapper">
        <div class="section-content">
          <h1 class="title">Set New Password</h1>
        </div>
        {#if change_status === "fail"}
          <div class="pt-3">
            <div class="alert alert-danger" role="alert">
              {change_status_data}
            </div>
          </div>
        {/if}
        {#if change_status === "pass"}
          <div class="pt-3">
            <div class="alert alert-success" role="alert">
              {change_status_data}
            </div>
          </div>
        {/if}
        <form
          on:submit|preventDefault={preventDefault}
          class="default-form-wrapper"
        >
          <ul class="default-form-list">
            <p>Enter OTP</p>
            <li class="single-form-item">
              <label for="otp" class="visually-hidden">otp</label>
              <input
                type="number"
                id="otp"
                placeholder="0000"
                maxlength="4"
                required
              />
              <span class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-key-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M3.5 11.5a3.5 3.5 0 1 1 3.163-5H14L15.5 8 14 9.5l-1-1-1 1-1-1-1 1-1-1-1 1H6.663a3.5 3.5 0 0 1-3.163 2zM2.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                  />
                </svg>
              </span>
            </li>
            <p>Enter new Password</p>
            <li class="single-form-item">
              <input
                type="password"
                id="newpassword"
                placeholder="*********"
                maxlength="15"
                required
              />
              <span class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-lock-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"
                  />
                </svg>
              </span>
            </li>
          </ul>
          <br />
          <button class="button-login" type="submit" id="submit"
            >Change Password</button
          >
        </form>
      </div>

      <div class="create-account-text text-center">
        Have an account?
        <Link to="/login" class="btn--color-radical-red">Login now</Link>
      </div>
      <div class="create-account-text text-center">
        Don't have an account?
        <Link to="/register" class="btn--color-radical-red">Create now</Link>
      </div>
    </div>
  </div>
  <!-- ...:::End User Event Section:::... -->
</main>
